<div class="ac-container" [ngClass]="{'error': showRequiredError, 'multiple': multiple}" [title]="getSelectedTitle()">
    <label *ngIf="!useCondensedView && (showLabel || value)" class="ac-label">{{placeholder}}</label>
    <form novalidate [formGroup]="autoSuggestForm">
        <div *ngIf="!useCondensedView">
            @if (multiple && showCheckboxes) {
                <p-multiselect
                    formControlName="modalValue"
                    [options]="_list"
                    [optionLabel]="field"
                    [optionValue]="dataKey"
                    [placeholder]="placeholder"
                    [filter]="true"
                    [showToggleAll]="true"
                    [disabled]="disabled"
                    appendTo="body"
                    styleClass="w-full"
                    panelStyleClass="ac-multiselect-panel"
                    (onChange)="onMultiSelectChange($event.value)">
                </p-multiselect>
            } @else {
        <p-autoComplete formControlName="modalValue" [suggestions]="filteredList" (completeMethod)="filterList($event)"
            [forceSelection]="true" 
            [placeholder]="showLabel || value ? '' : placeholder" 
            [optionLabel]="field"
            [optionValue]="dataKey"
            [dataKey]="dataKey" 
            panelStyleClass="ac-component" 
            inputStyleClass="ac-input" 
            delay="10" 
            (onSelect)="onSelect($event)" 
            (onUnselect)="onUnSelect($event)" 
            (onBlur)="onBlur($event)"
            (onDropdownClick)="onDropdownClick($event)" 
            (onClear)="onClear()" 
            [dropdown]="true" 
            appendTo="body"
            [multiple]="multiple"             
            [disabled]="disabled" 
            (onKeyUp)="onKeyUp($event)" 
            (onFocus)="showLabel = true; focusin.emit()"
            (ngModelChange)="valueChanges.emit(value)" 
            [optionDisabled]="optionDisabled"
            [attr.data-test-input-type]="inputTypeDropdown" >
            <ng-template let-item #item>
                <span [attr.data-test-value]="item[dataKey]"
                      style="pointer-events: auto"
                      [pTooltip]="optionDisabled && item[optionDisabled] && tooltipField ? item[tooltipField] : null"
                      tooltipPosition="right">
                    {{item[field]}}
                </span>
            </ng-template>
        </p-autoComplete>
            }
        </div>
        <p-floatlabel variant="in" *ngIf="useCondensedView">
            @if (multiple && showCheckboxes) {
                <p-multiselect
                    formControlName="modalValue"
                    [options]="_list"
                    [optionLabel]="field"
                    [optionValue]="dataKey"
                    [placeholder]="placeholder"
                    [filter]="true"
                    [showToggleAll]="true"
                    [disabled]="disabled"
                    appendTo="body"
                    styleClass="w-full"
                    panelStyleClass="ac-multiselect-panel"
                    (onChange)="onMultiSelectChange($event.value)">
                </p-multiselect>
            } @else {
            <p-autoComplete formControlName="modalValue" [suggestions]="filteredList" (completeMethod)="filterList($event)"
                inputId="in_label"
                [forceSelection]="true"              
                [optionLabel]="field"
                [optionValue]="dataKey"
                [dataKey]="dataKey" 
                panelStyleClass="ac-component" 
                inputStyleClass="ac-input" 
                delay="10" 
                (onSelect)="onSelect($event)" 
                (onUnselect)="onUnSelect($event)" 
                (onBlur)="onBlur($event)"
                (onDropdownClick)="onDropdownClick($event)" 
                (onClear)="onClear()" 
                [dropdown]="true" 
                appendTo="body"
                [multiple]="multiple"             
                [disabled]="disabled" 
                (onKeyUp)="onKeyUp($event)" 
                (onFocus)="focusin.emit()"
                (ngModelChange)="valueChanges.emit(value)" 
                [optionDisabled]="optionDisabled"
                [attr.data-test-input-type]="inputTypeDropdown" >
                <ng-template let-item #item>
                    <span [attr.data-test-value]="item[dataKey]"
                          style="pointer-events: auto"
                          [pTooltip]="optionDisabled && item[optionDisabled] && tooltipField ? item[tooltipField] : null"
                          tooltipPosition="right">
                        {{item[field]}}
                    </span>
                </ng-template>
            </p-autoComplete>
            }
            <label *ngIf="placeholder && placeholder.length && !(multiple && showCheckboxes)" for="in_label">{{placeholder}}</label>
        </p-floatlabel>
    </form>
    <div class="small text-danger w-50 d-inline-block" *ngIf="showRequiredError">required</div>
    <div class="small w-50 d-inline-block" *ngIf="!showRequiredError && multiple">Items Selected:
        <b>{{value.length}}</b>
    </div>
    <div class="small w-40 d-inline-block float-end text-end" *ngIf="allowNewValues == 'true'">Press semicolon key
        to add new value. <em>Ex: value;</em>.<br />Comma (,) is not allowed</div>
</div>
<!-- {{value | json}} -->